import fashions from '../assets/full-logo.png';
import rs from '../assets/Morgan@1.jpg';
import insurance from '../assets/nyumbaa.png';

export const data = [
    {
    id: 1,
    name: "INSURANCE WEBSITE",
    paragraph: "Full-stack app for insurance quotes and policy management. Integrated Spring Boot backend for secure data handling, serving 1k+ quotes monthly with 99% uptime.",
    image: insurance,
    github: "https://github.com/danielsdgg",
    live: "https://www.karendirectins.com/",
    tech: ["React", "Java (Spring Boot)", "MySQL", "REST APIs"],
  },
  {
    id: 2,
    name: "DALEON DYNAMICS",
    paragraph: "A software company website built with Next.js, showcasing services and projects with a responsive design and smooth navigation.",
    image: fashions,
    github: "https://github.com/danielsdgg",
    live: "https://daleondynamics.com/",
    tech: ["Nextjs",],
  },
  {
    id: 1,
    name: "Morgan-LMS",
    paragraph: "Developed a learning management system for Morgan Technical  Training that enhances remote learning with industry-ready skills.",
    image: rs,
    github: "https://github.com/danielsdgg/Morgantechnical.git", 
    live: "https://canvas-1-jxo5.onrender.com",
    tech: ["React", "Java (Spring Boot)", "MySQL", "Tailwind CSS", "API Integration"], 
  },


];